export default "__VITE_ASSET__DMHrB8j___"